import { zodResolver } from '@hookform/resolvers/zod'
import { FormProvider, useForm } from 'react-hook-form'
import { useCreateAcademy } from '../api'
import { AdminSchema, formSchema } from './schema'
import FormBuilder from '../../../../../components/app/formBuilder'
import { Button } from '../../../../../components/common'
import { useNavigate } from 'react-router-dom'

export default function AcademicCreate() {
  const navigate = useNavigate()
  const methods = useForm<AdminSchema>({
    resolver: zodResolver(formSchema),
    mode: 'onChange',
    reValidateMode: 'onChange',
  })

  const { mutate, isLoading: isCreating } = useCreateAcademy(onSuccess)

  function onSuccess() {
    methods.reset()
    navigate('/')
  }

  const { handleSubmit } = methods

  const onSubmit = (details: AdminSchema) => {
    const payload = {
      applicant_type: details.applicant_type,
      organization_name: details.organization_name,
      address: details.address,
      city: details.city,
      state_province: details.state_province,
      zip_postal_code: details.zip_postal_code,
      country: details.country,
      website: details.website,
      year_of_establishment: details.year_of_establishment,
      organization_description: details.organization_description,
      contact_name: details.contact_name,
      contact_title: details.contact_title,
      contact_email: details.contact_email,
      contact_phone: details.contact_phone ?? '',
    }

    mutate(payload)
  }

  const applicantType = [
    {
      name: 'applicant_type' as const,
      label: 'Select the type of organization you represent',
      type: 'custom_select' as const,
      placeholder: 'Select Type of organization',
      required: true,
      disabled: false,
      desc: 'name',
      descId: 'id',
      id: 'applicant_type',
      data: [
        { name: 'Industry Partner', id: 'industry_partner' },
        { name: 'Academic Institution', id: 'academic_institution' },
      ],
    },
  ]

  const organizationInformation = [
    {
      name: 'organization_name',
      label: 'Organization name',
      type: 'text',
      placeholder: 'Enter your Name',
      disabled: false,
      required: true,
    },
    {
      name: 'address',
      label: 'Full address',
      type: 'text',
      placeholder: 'Enter your Full Address',
      disabled: false,
      required: true,
    },
    {
      name: 'zip_postal_code',
      label: 'City, State/Province, ZIP/Postal Code',
      type: 'text',
      placeholder: 'Enter ZIP/Postal Code',
      disabled: false,
      required: true,
    },
    {
      name: 'country',
      label: 'Country',
      type: 'text',
      placeholder: 'Enter your Country',
      disabled: false,
      required: true,
    },
    {
      name: 'city',
      label: 'City',
      type: 'text',
      placeholder: 'Enter your City',
      disabled: false,
      required: true,
    },
    {
      name: 'state_province',
      label: 'State',
      type: 'text',
      placeholder: 'Enter your State',
      disabled: false,
      required: true,
    },
    {
      name: 'website',
      label: 'Website',
      type: 'text',
      placeholder: 'Enter your Website Link',
      disabled: false,
      required: true,
    },
    {
      name: 'year_of_establishment',
      label: 'Year of Establishment/Founding',
      type: 'number',
      placeholder: 'Enter Year (e.g., 2005)',
      disabled: false,
      required: true,
    },
    {
      name: 'organization_description',
      label:
        'Brief Description of Your Organization (Mission, Vision, Key Activities/Focus Areas)',
      type: 'text',
      placeholder: 'Enter your description',
      disabled: false,
      required: true,
    },
    {
      name: 'contact_name',
      label: 'Contact Name',
      type: 'text',
      placeholder: 'Enter Contact Name',
      disabled: false,
      required: true,
    },
    {
      name: 'contact_title',
      label: 'Contact Title',
      type: 'text',
      placeholder: 'Enter Contact Title',
      disabled: false,
      required: true,
    },
    {
      name: 'contact_email',
      label: 'Contact Email',
      type: 'text',
      placeholder: 'Enter Contact Email',
      disabled: false,
      required: true,
    },
    {
      name: 'contact_phone',
      label: 'Contact Phone',
      type: 'number',
      placeholder: 'Enter Contact Phone',
      disabled: false,
      required: true,
    },
  ]

  console.log(methods.formState.errors)
  return (
    <FormProvider {...methods}>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="flex flex-col lg:flex-row gap-6 lg:px-40 lg:py-14"
      >
        <div className="w-full space-y-6">
          <div>
            <div className="mb-4">
              <h2 className="text-xl font-medium">Applicant Type</h2>
              <p className="text-LightGray text-sm">
                Please Fill Out All Required Fields
              </p>
            </div>
            <div className="grid grid-cols-1 gap-6">
              <FormBuilder data={applicantType} />
            </div>
          </div>

          <div>
            <div className="mb-4">
              <h2 className="text-xl font-medium">Organization Information</h2>
            </div>
            <div className="grid grid-cols-1 gap-6">
              <FormBuilder data={organizationInformation} edit />
            </div>
          </div>

          {/* Submit */}
          <div className="flex gap-3 mt-4 w-full justify-end">
            <Button
              type="submit"
              className="px-10 py-2 text-white rounded disabled:opacity-50 w-full !bg-primaryOrange"
              disabled={isCreating}
              label="Submit"
            />
          </div>

          {/* Debugging */}
          {/* Uncomment for debugging form errors */}
          {/* <pre>{JSON.stringify(methods.formState.errors, null, 2)}</pre> */}
        </div>
      </form>
    </FormProvider>
  )
}
